$(document).ready(function () {
    'use strict';

    if (windowWidth <= 1024) {
        var franchiseMenuDropdown = $(".newFranchiseHeader .dropdownLink"),
            subMenuDropdown = $(".newFranchiseHeader .sub h2");

        if (franchiseMenuDropdown.length > 0) {
            franchiseMenuDropdown.click(function(e) {
                e.preventDefault();

                $(this).next().toggleClass("active");
                $(this).closest("li").find(".sub").toggleClass("active");
            });
        }

        if (subMenuDropdown.length > 0) {
            subMenuDropdown.click(function() {
                $(this).find(".slideIcon").toggleClass("active");
                $(this).next().toggleClass("active");
            });
        }
    }
});
